export default class FilaStatusTicketModel {
  constructor({
    id = 0,
    filaId = 0,
    nome = '',
    descricao = '',
    categoriaStatusId = 0,
    ordem = 0,
    ativo = false,
    principal = false,
  } = {}) {
    this.id = id
    this.filaId = filaId
    this.nome = nome
    this.descricao = descricao
    this.categoriaStatusId = categoriaStatusId
    this.ordem = ordem
    this.ativo = ativo
    this.principal = principal
  }
}
